<template>
    <div class="grid grid-cols-4 gap-16">
        <div class="col-span-4">
            <div class="flex justify-between mb-24">
                <p class="text-heading-1 font-semibold">{{ $t('multi-posting.tabs.social-boosts.label') }}</p>
                <simple-button
                    look="primary"
                    icon="keyboard-arrow-left"
                    icon-position="left"
                    @click="close"
                >
                    {{ $t('multi-posting.back-to-tab', {tab: $t('multi-posting.tabs.social-boosts.label').toLowerCase()}) }}
                </simple-button>
            </div>
            <div class="border-t w-full"></div>
        </div>

        <div class="col-span-3">
            <div class="flex justify-between mb-24">
                <p class="text-heading-1 font-bold">{{ $t('general.review') }}</p>
            </div>

            <div class="mt-4 p-4">
                <div class="flex">
                    <p class="w-320 font-semibold my-4 capitalize">{{ $t('social_boost.popup.vacancy.title') }}</p>
                    <p>{{ job.title[selectedLocale] }}</p>
                </div>
                <div class="flex">
                    <p class="w-320 font-semibold my-4 capitalize">{{ $t('general.start_date') }}</p>
                    <p>{{ startDate }}</p>
                </div>
                <div class="flex">
                    <p class="w-320 font-semibold my-4 capitalize">{{ $t('general.end_date') }}</p>
                    <p>{{ endDate }}</p>
                </div>
                <div class="flex">
                    <p class="w-320 font-semibold my-4 capitalize">{{ $t('campaigns.reference_id') }}</p>
                    <p>{{ referenceId }}</p>
                </div>
                <div class="flex">
                    <p class="w-320 font-semibold my-4 capitalize">{{ $t('jobs.apply_url') }}</p>
                    <p>{{ job.url[this.selectedLocale] }}</p>
                </div>
            </div>
        </div>

        <div class="col-span-1">
            <slot name="basket"></slot>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import {useMainStore} from '../../state/store';
import SimpleButton from "../ui/SimpleButton.vue";

export default {
    name: 'SocialBoostFormReview',
    components: {SimpleButton},
    props: {
        job: {
            type: Object,
            required: true
        },
        boost: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dateRange: {
                start: null,
                end: null,
            },
        }
    },
    computed: {
        ...mapState(useMainStore, ['selectedLocale']),
        startDate() {
            if (!this.dateRange.start) return ""
            return this.formatDate(this.dateRange.start)
        },
        endDate() {
            if (!this.dateRange.end) return ""
            return this.formatDate(this.dateRange.end)
        },
        referenceId() {
            return (this.boost.title[this.selectedLocale] + ": " + this.job.title[this.selectedLocale]).toLowerCase();
        }
    },
    methods: {
        ...mapActions('multiPosting', ['clearSelectedItems']),
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        setDateRange() {
            const startDate = new Date()
            const endDate = new Date()
            endDate.setDate(startDate.getDate() + this.boost.duration)
            this.dateRange = {
                start: startDate,
                end: endDate
            }
        },
        close() {
            this.clearSelectedItems();
            this.$emit('close');
        }
    },
    mounted() {
        this.setDateRange()
    }
}
</script>

